import React, { useEffect, useState } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { CardWrapperDetailsPage } from '../../../../common/CardWrapper';
import { ANALYTICS_CONSTANTS } from '../../../../common/CareTeamCard/CareTeamUtils';
import { CareTeamHeader } from '../../../../common/CareTeamHeader';
import { ConstantsLagoon } from '../../../../common/ConstantsLagoon';
import { getFeatureFlag } from '../../../../common/Utils';
import { useAdobePageTrackEvent } from '../../../../hooks/adobeHook/useAdobePageTrackEvent';
import { useLagoon } from '../../../../hooks/useLagoon';
import { useCareTeamStore } from '../../../../store/useCareTeamStore';
import { CareTeamState } from '../../../../store/useCareTeamStore/careTeamStore';
import {
  getLoggedInMember,
  isGroupMNRMember,
} from '../../../../utils/user.utils';
import { CareTeamDetailPage } from './CareTeamDetailPage';

export const CareTeamView = () => {
  const [pcpProvider, setPcpProvider] = useState(null);
  const [pcpChipValue, setPCPChipValue] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const featureFlags = useLagoon('feature-flags')();
  const enableCareTeamView = getFeatureFlag(
    featureFlags,
    ConstantsLagoon.FEATURE_FLAGS.ENABLE_CARE_TEAM_VIEW
  );
  const allConfigs = useLagoon('config')();
  const maximumProviderLimit = allConfigs?.find(
    (row) => row.key === 'MAXIMUM_PROVIDER_LIMIT_FOR_CARETEAM'
  )?.value;

  const { adobePageTrackEvent } = useAdobePageTrackEvent({
    pageName: ANALYTICS_CONSTANTS.CARE_TEAM,
  });

  const { careTeamProviderCount, setShowMaximumProviderLimitBanner } =
    useCareTeamStore(
      useShallow((state: CareTeamState) => ({
        careTeamProviderCount: state.careTeamProviderCount,
        setShowMaximumProviderLimitBanner:
          state.setShowMaximumProviderLimitBanner,
      }))
    );
  const loggedInMemberInfo = getLoggedInMember();

  const hidePCPCard =
    !loggedInMemberInfo?.viewPcp || isGroupMNRMember(loggedInMemberInfo);

  const showMaximumProviderLimitBanner =
    careTeamProviderCount >=
    Number(maximumProviderLimit) - (hidePCPCard ? 0 : 1);

  useEffect(() => {
    setShowMaximumProviderLimitBanner(showMaximumProviderLimitBanner);
  }, [showMaximumProviderLimitBanner, setShowMaximumProviderLimitBanner]);

  useEffect(() => {
    enableCareTeamView && adobePageTrackEvent();
  }, [adobePageTrackEvent, enableCareTeamView]);

  if (!enableCareTeamView) {
    return null;
  }

  return (
    <React.Fragment>
      <CareTeamHeader
        chipValue={pcpChipValue}
        pageNumber={pageNumber}
        pcpProvider={pcpProvider}
      />
      <CardWrapperDetailsPage>
        <CareTeamDetailPage
          setPCPChipValue={setPCPChipValue}
          setParentPageNumber={setPageNumber}
          setPcpProvider={setPcpProvider}
        />
      </CardWrapperDetailsPage>
    </React.Fragment>
  );
};
